import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=69fca668"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fca668')) {
      api.createRecord('69fca668', component.options)
    } else {
      api.reload('69fca668', component.options)
    }
    module.hot.accept("./FormSwitch.vue?vue&type=template&id=69fca668", function () {
      api.rerender('69fca668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormSwitch.vue"
export default component.exports